export default __webpack_public_path__ + "static/media/Jason_Aronsberg.88f3c2cb.png";